import BaseApplication from "pages/BaseApplication"
import ApplicationDetails from "../Exports/ApplicationDetails"
import Documents from "../Exports/Documents"
import { useEffect, useState } from "react"
import Licensing from "services/Licensing.service"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)
let generalService = new General(user)


const Apply = props => {
  const [loading, setloading] = useState(false)
  const [submitted, setsubmitted] = useState(false)
  const [applicationId, setapplicationId] = useState()
  const [serviceAttachments, setserviceAttachments] = useState()
  const [mounted, setmounted] = useState(false)
  const [service,setService] = useState([])

  useEffect(() => {
    licensingService.createApplication(props.service_id).then(response => {
      console.log("creating export application", response)
      setapplicationId(response.data.id)
    })
    fetchAttachments(props.service_id)

    if(props.service_id==3)
    {
      setService("Apply | Import License")
    }
    else 
    setService("Apply | Export License")
  }, [])

  const submitApplication = data => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
      setsubmitted(true)
    }, 4000)

    console.log(data.formData)
    if(data.formData.convention === "basel") {
      prepareWasteIds(data.formData)
      prepareCountriesStates(data.formData)
    }
    saveApplication(data.formData)
    saveAttachments(data.docs)
  }

  const fetchAttachments = service_id => {
    generalService.getServiceAttachments(service_id).then(response => {
      console.log("service atts", response.data)
      if (response.status) {
        setserviceAttachments(response.data)
      }
    })
  }

  const saveApplication = formData => {
    if (formData.convention === "basel") {
      licensingService
        .saveApplicationBasel({
          ...formData,
          application_id: applicationId,
          service_id: props.service_id,
        })
        .then(response => {
          if (response.status) {
            //
          }
        })
    } else {
      licensingService
        .saveApplicationRotterdam({
          ...formData,
          application_id: applicationId,
          service_id: props.service_id,
        })
        .then(response => {
          if (response.status) {
            //
          }
        })
    }
  }

  const prepareWasteIds = formData => {
    let inputName = "wasteid_"
    let wastesIdsArr = []
    var code = ""
    licensingService.getAllWasteIdentifications().then(response => {
      if (response.status) {
        response.data.forEach(item => {
          inputName = "wasteid_" + item.id
          code = formData[inputName]
          code = code.trim()
          if (code != "") {
            wastesIdsArr.push({
              code: code,
              waste_identification_id: item.id,
            })
          }
        })
      }
      
      licensingService
        .saveApplicantWasteIds(applicationId, wastesIdsArr)
        .then(response => {
          console.log("submitted waste ids", response)
          if (response.status) {
          }
        })
    })
  }

  const prepareCountriesStates = formData => {
    let exportInput = ""
    let importInput = ""
    let transitInput = ""
    let transitStates = []
    for (let kount = 0; kount < 10; kount++) {
      exportInput = "export_" + kount
      importInput = "import_" + kount
      transitInput = "transit_" + kount

      let exp = formData[exportInput]
      let imp = formData[importInput]
      let tran = formData[transitInput]

      if (exp != undefined) {
        exp = exp.trim()
        imp = imp.trim()
        tran = tran.trim()

        if (exp != "" && imp != "") {
          transitStates.push({
            state_of_dispatch: exp,
            state_of_transit: tran,
            state_of_destination: imp,
          })
        }
      }
    }
    
    licensingService
      .saveTransitStates(applicationId, transitStates)
      .then(response => {
        console.log("submission states via api ", response)
        if (response.status) {
        }
      })
  }

  const saveAttachments = attachments => {
    generalService.bulkFileUpload(attachments)
  }

  return (
    <>
      <BaseApplication
      editMode={false}
        loading={loading}
        submitted={submitted}
        submit={submitApplication}
        title={service}
        service={service}
        formOne={<ApplicationDetails editMode={false} />}
        formTwo={<Documents service_id={props.service_id} />}
        applicationId={applicationId}
        attachments={serviceAttachments}
      />
    </>
  )
}

export default Apply
